/*
 *
 * LabelTemplates
 *
 */

import React from "react"
import { connect } from "react-redux"
import {
	setTitle,
	delayedDispatch,
	setBreadcrumb,
	updateCrumb,
	setLoader,
} from "store/actions"
import { push } from "connected-react-router"
import { Helmet } from "react-helmet"
import { Table } from "components"
import { notification } from "antd"
import Strings from "utils/strings"
import { API, Endpoints } from "utils/api"
import "./styles.scss"

class LabelTemplates extends React.Component<any, any> {
	constructor(props: any) {
		super(props)

		this.state = {
			labelTemplates: [],
		}
	}

	componentDidMount() {
		const { dispatch } = this.props

		dispatch(setTitle(""))

		delayedDispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.sidebar.settings,
						route: "/settings",
						icon: "preferences",
					},
					{
						text: Strings.settings.labelTemplates,
						icon: "tag",
					},
				],
			}))
		)

		this.getData()
	}

	componentDidUpdate() {
		const { dispatch } = this.props
		dispatch(updateCrumb())
	}

	async getData() {
		const { dispatch } = this.props

		dispatch(setLoader(true))

		try {
			const response = await API.get({
				url: Endpoints.uriLabelTemplates(),
			})

			if (response.ok) {
				const { labelTemplates = [] } = response.data.results || {}
				this.setState({ labelTemplates })
			} else {
				notification.error({
					message: Strings.settings.labelTemplates,
					description:
						response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5,
				})
			}
		} catch (err) {
			notification.error({
				message: Strings.settings.labelTemplates,
				description: Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5,
			})
		}

		dispatch(setLoader(false))
	}

	render() {
		const { labelTemplates = [] } = this.state
		const { dispatch } = this.props

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.settings.labelTemplates}</title>
					<meta
						name="description"
						content={Strings.settings.labelTemplatesDescription}
					/>
				</Helmet>
				<Table
					title={{
						icon: "tag",
						title: Strings.settings.labelTemplates,
					}}
					data={labelTemplates}
					columns={[
						{
							Header: Strings.fields.name,
							id: "label_name",
							accessor: (row: any) => row.name || "-",
						},
						{
							Header: Strings.settings.lastModifiedBy,
							id: "label_last_modified",
							accessor: (row: any) => row.lastModifiedBy?.name || "-",
						},
					]}
					fullPage
					isSinglePage
					filterable
					sortable
					add={{
						onClick: () => dispatch(push("/settings/label-templates/new")),
					}}
					actions={{
						edit: (row: any) => ({
							onClick: () =>
								dispatch(push(`/settings/label-templates/${row._id}`)),
						}),
					}}
				/>
			</React.Fragment>
		)
	}
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(LabelTemplates)
